var _rect, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _g36, _g37, _g38, _g39, _g40, _g41, _g42, _g43, _g44, _g45, _g46, _g47, _g48, _g49, _g50, _g51, _g52, _g53, _g54, _g55, _g56, _g57, _g58, _g59, _g60, _g61, _g62, _g63, _g64, _g65, _g66, _g67, _g68, _g69, _g70, _g71, _g72, _g73, _g74, _g75, _g76, _g77, _g78, _g79, _g80, _g81, _g82, _g83, _g84, _g85, _g86, _g87, _g88, _g89, _g90, _g91, _g92, _g93, _g94, _g95, _g96, _g97, _g98, _g99, _g100, _g101, _g102, _g103, _g104, _g105, _g106, _g107, _g108, _g109;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginWallpaper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1920,
    height: 1080,
    fill: "#F5F7FA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.76 808.012H160.176V1080H245.76V808.012Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246 808H203V1080H246V808Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.171 781.294H169.949V807.994H200.171V781.294Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.171 781.294H192.965V807.994H200.171V781.294Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.041 808.012V806.45H248.275V808.012",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.307 819.658H177.066V834.978H184.307V819.658Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.968 840.978C202.968 841.138 193.39 841.262 181.563 841.262C169.736 841.262 160.158 841.138 160.158 840.978C160.158 840.818 169.736 840.694 181.563 840.694C193.39 840.694 202.968 840.818 202.968 840.978Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.472 819.657H220.231V834.978H227.472V819.657Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.132 840.978C246.132 841.137 236.554 841.262 224.727 841.262C212.901 841.262 203.322 841.137 203.322 840.978C203.322 840.818 212.901 840.694 224.727 840.694C236.554 840.694 246.132 840.818 246.132 840.978Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.472 850.068H220.231V865.389H227.472V850.068Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.132 871.389C246.132 871.549 236.554 871.673 224.727 871.673C212.901 871.673 203.322 871.549 203.322 871.389C203.322 871.229 212.901 871.105 224.727 871.105C236.554 871.105 246.132 871.229 246.132 871.389Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.472 881.384H220.231V896.704H227.472V881.384Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.133 902.722C246.133 902.882 236.555 903.006 224.728 903.006C212.901 903.006 203.323 902.882 203.323 902.722C203.323 902.562 212.901 902.438 224.728 902.438C236.555 902.438 246.133 902.562 246.133 902.722Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.472 912.718H220.231V928.038H227.472V912.718Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.132 934.057C246.132 934.216 236.554 934.341 224.727 934.341C212.901 934.341 203.322 934.216 203.322 934.057C203.322 933.897 212.901 933.773 224.727 933.773C236.554 933.755 246.132 933.897 246.132 934.057Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.472 943.163H220.231V958.483H227.472V943.163Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.132 964.483C246.132 964.642 236.554 964.767 224.727 964.767C212.901 964.767 203.322 964.642 203.322 964.483C203.322 964.323 212.901 964.199 224.727 964.199C236.554 964.199 246.132 964.323 246.132 964.483Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.472 973.715H220.231V989.036H227.472V973.715Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.472 1004.68H220.231V1020H227.472V1004.68Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.133 995.036C246.133 995.195 236.554 995.32 224.728 995.32C212.901 995.32 203.323 995.195 203.323 995.036C203.323 994.876 212.901 994.751 224.728 994.751C236.554 994.751 246.133 994.876 246.133 995.036Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.308 850.529H177.067V865.85H184.308V850.529Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.968 871.85C202.968 872.01 193.39 872.134 181.563 872.134C169.737 872.134 160.158 872.01 160.158 871.85C160.158 871.69 169.737 871.566 181.563 871.566C193.39 871.566 202.968 871.69 202.968 871.85Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.308 881.401H177.066V896.722H184.308V881.401Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.968 902.741C202.968 902.9 193.39 903.025 181.563 903.025C169.737 903.025 160.158 902.9 160.158 902.741C160.158 902.581 169.737 902.457 181.563 902.457C193.39 902.439 202.968 902.581 202.968 902.741Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.308 912.273H177.067V927.594H184.308V912.273Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.968 933.612C202.968 933.772 193.39 933.896 181.563 933.896C169.736 933.896 160.158 933.772 160.158 933.612C160.158 933.452 169.736 933.328 181.563 933.328C193.39 933.31 202.968 933.452 202.968 933.612Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.307 943.163H177.066V958.483H184.307V943.163Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.968 964.483C202.968 964.643 193.39 964.767 181.563 964.767C169.736 964.767 160.158 964.643 160.158 964.483C160.158 964.323 169.736 964.199 181.563 964.199C193.39 964.199 202.968 964.323 202.968 964.483Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.308 974.035H177.067V989.356H184.308V974.035Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.968 995.355C202.968 995.515 193.39 995.639 181.563 995.639C169.737 995.639 160.158 995.515 160.158 995.355C160.158 995.196 169.737 995.071 181.563 995.071C193.39 995.071 202.968 995.196 202.968 995.355Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.308 1004.91H177.066V1020.23H184.308V1004.91Z",
    fill: "#FAFAFA"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M687.57 807.939H601.985V1079.19H687.57V807.939Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688 808H645V1080H688V808Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.981 781.294H611.759V807.922H641.981V781.294Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.981 781.294H634.775V807.922H641.981V781.294Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M594.851 807.94V806.382H690.084V807.94",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.117 819.554H618.876V834.833H626.117V819.554Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.778 840.817C644.778 840.976 635.199 841.1 623.373 841.1C611.546 841.1 601.968 840.976 601.968 840.817C601.968 840.657 611.546 840.533 623.373 840.533C635.199 840.533 644.778 840.657 644.778 840.817Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.281 819.554H662.04V834.833H669.281V819.554Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.942 840.817C687.942 840.976 678.364 841.1 666.537 841.1C654.71 841.1 645.132 840.976 645.132 840.817C645.132 840.657 654.71 840.533 666.537 840.533C678.364 840.533 687.942 840.657 687.942 840.817Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.281 849.883H662.04V865.162H669.281V849.883Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.942 871.146C687.942 871.305 678.364 871.429 666.537 871.429C654.71 871.429 645.132 871.305 645.132 871.146C645.132 870.986 654.71 870.862 666.537 870.862C678.364 870.862 687.942 870.986 687.942 871.146Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.282 881.114H662.04V896.393H669.282V881.114Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.942 902.395C687.942 902.554 678.364 902.678 666.537 902.678C654.711 902.678 645.132 902.554 645.132 902.395C645.132 902.235 654.711 902.111 666.537 902.111C678.364 902.111 687.942 902.235 687.942 902.395Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.281 912.363H662.04V927.642H669.281V912.363Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.942 933.644C687.942 933.804 678.364 933.927 666.537 933.927C654.71 933.927 645.132 933.804 645.132 933.644C645.132 933.485 654.71 933.361 666.537 933.361C678.364 933.343 687.942 933.485 687.942 933.644Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.281 942.726H662.04V958.005H669.281V942.726Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.942 963.989C687.942 964.148 678.364 964.272 666.537 964.272C654.71 964.272 645.132 964.148 645.132 963.989C645.132 963.829 654.71 963.705 666.537 963.705C678.364 963.705 687.942 963.829 687.942 963.989Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.281 973.196H662.04V988.475H669.281V973.196Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M669.281 1004.07H662.04V1019.35H669.281V1004.07Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.942 994.459C687.942 994.618 678.364 994.742 666.537 994.742C654.71 994.742 645.132 994.618 645.132 994.459C645.132 994.299 654.71 994.176 666.537 994.176C678.364 994.176 687.942 994.299 687.942 994.459Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.117 850.343H618.876V865.622H626.117V850.343Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.778 871.606C644.778 871.765 635.2 871.889 623.373 871.889C611.546 871.889 601.968 871.765 601.968 871.606C601.968 871.446 611.546 871.322 623.373 871.322C635.2 871.322 644.778 871.446 644.778 871.606Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.117 881.131H618.876V896.41H626.117V881.131Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.778 902.413C644.778 902.572 635.2 902.696 623.373 902.696C611.546 902.696 601.968 902.572 601.968 902.413C601.968 902.253 611.546 902.129 623.373 902.129C635.2 902.112 644.778 902.253 644.778 902.413Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.117 911.92H618.876V927.199H626.117V911.92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.778 933.201C644.778 933.36 635.199 933.484 623.373 933.484C611.546 933.484 601.968 933.36 601.968 933.201C601.968 933.042 611.546 932.918 623.373 932.918C635.199 932.9 644.778 933.042 644.778 933.201Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.117 942.726H618.876V958.005H626.117V942.726Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.778 963.989C644.778 964.148 635.199 964.272 623.373 964.272C611.546 964.272 601.968 964.148 601.968 963.989C601.968 963.829 611.546 963.705 623.373 963.705C635.199 963.705 644.778 963.829 644.778 963.989Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.117 973.515H618.876V988.794H626.117V973.515Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.778 994.778C644.778 994.937 635.2 995.061 623.373 995.061C611.546 995.061 601.968 994.937 601.968 994.778C601.968 994.618 611.546 994.494 623.373 994.494C635.2 994.494 644.778 994.618 644.778 994.778Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.117 1004.3H618.876V1019.58H626.117V1004.3Z",
    fill: "#FAFAFA"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1236.68 807.939H1322.26V1079.19H1236.68V807.939Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.68 807.939H1279.47V1080H1236.68V807.939Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.27 781.294H1312.49V807.922H1282.27V781.294Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1282.27 781.294H1289.47V807.922H1282.27V781.294Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1329.4 807.94V806.382H1234.16V807.94",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.13 819.554H1305.37V834.833H1298.13V819.554Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.47 840.817C1279.47 840.976 1289.05 841.1 1300.87 841.1C1312.7 841.1 1322.28 840.976 1322.28 840.817C1322.28 840.657 1312.7 840.533 1300.87 840.533C1289.05 840.533 1279.47 840.657 1279.47 840.817Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.96 819.554H1262.21V834.833H1254.96V819.554Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.3 840.817C1236.3 840.976 1245.88 841.1 1257.71 841.1C1269.54 841.1 1279.11 840.976 1279.11 840.817C1279.11 840.657 1269.54 840.533 1257.71 840.533C1245.88 840.533 1236.3 840.657 1236.3 840.817Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.96 849.883H1262.21V865.162H1254.96V849.883Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.3 871.146C1236.3 871.305 1245.88 871.429 1257.71 871.429C1269.54 871.429 1279.11 871.305 1279.11 871.146C1279.11 870.986 1269.54 870.862 1257.71 870.862C1245.88 870.862 1236.3 870.986 1236.3 871.146Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.96 881.114H1262.21V896.393H1254.96V881.114Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.3 902.394C1236.3 902.554 1245.88 902.678 1257.71 902.678C1269.54 902.678 1279.11 902.554 1279.11 902.394C1279.11 902.235 1269.54 902.111 1257.71 902.111C1245.88 902.111 1236.3 902.235 1236.3 902.394Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.96 912.363H1262.21V927.642H1254.96V912.363Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.3 933.644C1236.3 933.804 1245.88 933.927 1257.71 933.927C1269.54 933.927 1279.11 933.804 1279.11 933.644C1279.11 933.485 1269.54 933.361 1257.71 933.361C1245.88 933.343 1236.3 933.485 1236.3 933.644Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.96 942.726H1262.21V958.005H1254.96V942.726Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.3 963.989C1236.3 964.148 1245.88 964.272 1257.71 964.272C1269.54 964.272 1279.11 964.148 1279.11 963.989C1279.11 963.829 1269.54 963.705 1257.71 963.705C1245.88 963.705 1236.3 963.829 1236.3 963.989Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.96 973.196H1262.21V988.475H1254.96V973.196Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1254.96 1004.07H1262.21V1019.35H1254.96V1004.07Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1236.3 994.459C1236.3 994.618 1245.88 994.742 1257.71 994.742C1269.54 994.742 1279.11 994.618 1279.11 994.459C1279.11 994.299 1269.54 994.176 1257.71 994.176C1245.88 994.176 1236.3 994.299 1236.3 994.459Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.13 850.343H1305.37V865.622H1298.13V850.343Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.47 871.606C1279.47 871.765 1289.05 871.889 1300.87 871.889C1312.7 871.889 1322.28 871.765 1322.28 871.606C1322.28 871.446 1312.7 871.322 1300.87 871.322C1289.05 871.322 1279.47 871.446 1279.47 871.606Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.13 881.131H1305.37V896.41H1298.13V881.131Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.47 902.413C1279.47 902.572 1289.05 902.696 1300.87 902.696C1312.7 902.696 1322.28 902.572 1322.28 902.413C1322.28 902.253 1312.7 902.129 1300.87 902.129C1289.05 902.112 1279.47 902.253 1279.47 902.413Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.13 911.92H1305.37V927.199H1298.13V911.92Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.47 933.201C1279.47 933.36 1289.05 933.484 1300.87 933.484C1312.7 933.484 1322.28 933.36 1322.28 933.201C1322.28 933.042 1312.7 932.918 1300.87 932.918C1289.05 932.9 1279.47 933.042 1279.47 933.201Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.13 942.726H1305.37V958.005H1298.13V942.726Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.47 963.989C1279.47 964.148 1289.05 964.272 1300.87 964.272C1312.7 964.272 1322.28 964.148 1322.28 963.989C1322.28 963.829 1312.7 963.705 1300.87 963.705C1289.05 963.705 1279.47 963.829 1279.47 963.989Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.13 973.515H1305.37V988.794H1298.13V973.515Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.47 994.778C1279.47 994.937 1289.05 995.061 1300.87 995.061C1312.7 995.061 1322.28 994.937 1322.28 994.778C1322.28 994.618 1312.7 994.494 1300.87 994.494C1289.05 994.494 1279.47 994.618 1279.47 994.778Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1298.13 1004.3H1305.37V1019.58H1298.13V1004.3Z",
    fill: "#FAFAFA"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M849.486 761.671H949.474V1080H849.486V761.671Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849 762H899V1080H849V762Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.728 730.562H938.036V761.671H902.728V730.562Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.728 730.562H911.147V761.671H902.728V730.562Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M957.79 761.671V759.851H846.549V761.671",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.261 775.239H929.721V793.09H921.261V775.239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.46 800.102C899.46 800.288 910.65 800.433 924.467 800.433C938.284 800.433 949.474 800.288 949.474 800.102C949.474 799.916 938.284 799.771 924.467 799.771C910.65 799.75 899.46 799.916 899.46 800.102Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.833 775.24H879.293V793.09H870.833V775.24Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.033 800.102C849.033 800.288 860.223 800.433 874.04 800.433C887.857 800.433 899.047 800.288 899.047 800.102C899.047 799.916 887.857 799.771 874.04 799.771C860.223 799.75 849.033 799.916 849.033 800.102Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.833 810.672H879.293V828.522H870.833V810.672Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.033 835.535C849.033 835.721 860.223 835.866 874.04 835.866C887.857 835.866 899.047 835.721 899.047 835.535C899.047 835.348 887.857 835.204 874.04 835.204C860.223 835.183 849.033 835.348 849.033 835.535Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.833 847.179H879.293V865.03H870.833V847.179Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.033 872.043C849.033 872.229 860.223 872.374 874.04 872.374C887.857 872.374 899.047 872.229 899.047 872.043C899.047 871.857 887.857 871.712 874.04 871.712C860.223 871.691 849.033 871.857 849.033 872.043Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.833 883.688H879.293V901.538H870.833V883.688Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.033 908.529C849.033 908.715 860.223 908.86 874.04 908.86C887.857 908.86 899.047 908.715 899.047 908.529C899.047 908.343 887.857 908.198 874.04 908.198C860.223 908.198 849.033 908.343 849.033 908.529Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.833 919.141H879.293V936.991H870.833V919.141Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.032 944.003C849.032 944.189 860.222 944.334 874.039 944.334C887.856 944.334 899.047 944.189 899.047 944.003C899.047 943.816 887.856 943.672 874.039 943.672C860.222 943.651 849.032 943.816 849.032 944.003Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.833 954.738H879.293V972.589H870.833V954.738Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M870.833 990.812H879.293V1008.66H870.833V990.812Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.033 979.6C849.033 979.786 860.223 979.931 874.04 979.931C887.857 979.931 899.047 979.786 899.047 979.6C899.047 979.414 887.857 979.269 874.04 979.269C860.223 979.269 849.033 979.414 849.033 979.6Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.261 811.21H929.721V829.061H921.261V811.21Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.46 836.072C899.46 836.258 910.65 836.403 924.467 836.403C938.284 836.403 949.474 836.258 949.474 836.072C949.474 835.886 938.284 835.741 924.467 835.741C910.65 835.72 899.46 835.886 899.46 836.072Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.261 847.201H929.721V865.051H921.261V847.201Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.46 872.043C899.46 872.229 910.65 872.374 924.467 872.374C938.284 872.374 949.474 872.229 949.474 872.043C949.474 871.857 938.284 871.712 924.467 871.712C910.65 871.712 899.46 871.857 899.46 872.043Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.261 883.171H929.721V901.021H921.261V883.171Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.46 908.012C899.46 908.198 910.65 908.343 924.467 908.343C938.284 908.343 949.474 908.198 949.474 908.012C949.474 907.826 938.284 907.681 924.467 907.681C910.65 907.681 899.46 907.826 899.46 908.012Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.261 919.141H929.721V936.991H921.261V919.141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.46 944.003C899.46 944.189 910.651 944.334 924.468 944.334C938.285 944.334 949.475 944.189 949.475 944.003C949.475 943.817 938.285 943.672 924.468 943.672C910.651 943.651 899.46 943.817 899.46 944.003Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.261 955.11H929.721V972.961H921.261V955.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.46 979.973C899.46 980.159 910.651 980.304 924.468 980.304C938.285 980.304 949.475 980.159 949.475 979.973C949.475 979.787 938.285 979.642 924.468 979.642C910.651 979.642 899.46 979.787 899.46 979.973Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.261 991.101H929.721V1008.95H921.261V991.101Z",
    fill: "#FAFAFA"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M407.676 761.671H507.664V1080H407.676V761.671Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.656 761.671H457.65V1080H407.656V761.671Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.918 730.561H496.226V761.671H460.918V730.561Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.918 730.561H469.337V761.671H460.918V730.561Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.979 761.671V759.85H404.739V761.671",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.451 775.239H487.911V793.09H479.451V775.239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.65 800.102C457.65 800.288 468.84 800.433 482.657 800.433C496.474 800.433 507.664 800.288 507.664 800.102C507.664 799.916 496.474 799.771 482.657 799.771C468.84 799.75 457.65 799.916 457.65 800.102Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.023 775.24H437.483V793.09H429.023V775.24Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.221 800.102C407.221 800.288 418.412 800.433 432.229 800.433C446.046 800.433 457.236 800.288 457.236 800.102C457.236 799.916 446.046 799.771 432.229 799.771C418.412 799.75 407.221 799.916 407.221 800.102Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.023 810.672H437.483V828.522H429.023V810.672Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.221 835.535C407.221 835.721 418.412 835.865 432.229 835.865C446.046 835.865 457.236 835.721 457.236 835.535C457.236 835.348 446.046 835.204 432.229 835.204C418.412 835.183 407.221 835.348 407.221 835.535Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.023 847.179H437.483V865.03H429.023V847.179Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.221 872.043C407.221 872.229 418.412 872.374 432.229 872.374C446.046 872.374 457.236 872.229 457.236 872.043C457.236 871.857 446.046 871.712 432.229 871.712C418.412 871.691 407.221 871.857 407.221 872.043Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.023 883.688H437.483V901.538H429.023V883.688Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.221 908.529C407.221 908.715 418.412 908.86 432.229 908.86C446.046 908.86 457.236 908.715 457.236 908.529C457.236 908.343 446.046 908.198 432.229 908.198C418.412 908.198 407.221 908.343 407.221 908.529Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.023 919.141H437.483V936.991H429.023V919.141Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.221 944.002C407.221 944.189 418.412 944.333 432.229 944.333C446.046 944.333 457.236 944.189 457.236 944.002C457.236 943.816 446.046 943.671 432.229 943.671C418.412 943.651 407.221 943.816 407.221 944.002Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.023 954.738H437.483V972.588H429.023V954.738Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.023 990.812H437.483V1008.66H429.023V990.812Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.221 979.6C407.221 979.786 418.412 979.931 432.229 979.931C446.046 979.931 457.236 979.786 457.236 979.6C457.236 979.414 446.046 979.269 432.229 979.269C418.412 979.269 407.221 979.414 407.221 979.6Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.451 811.21H487.911V829.06H479.451V811.21Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.65 836.072C457.65 836.258 468.84 836.403 482.657 836.403C496.474 836.403 507.664 836.258 507.664 836.072C507.664 835.886 496.474 835.741 482.657 835.741C468.84 835.72 457.65 835.886 457.65 836.072Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.451 847.201H487.911V865.051H479.451V847.201Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.65 872.043C457.65 872.229 468.84 872.374 482.657 872.374C496.474 872.374 507.664 872.229 507.664 872.043C507.664 871.857 496.474 871.712 482.657 871.712C468.84 871.712 457.65 871.857 457.65 872.043Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.451 883.17H487.911V901.021H479.451V883.17Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.65 908.012C457.65 908.198 468.84 908.343 482.657 908.343C496.474 908.343 507.664 908.198 507.664 908.012C507.664 907.826 496.474 907.681 482.657 907.681C468.84 907.681 457.65 907.826 457.65 908.012Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.451 919.141H487.911V936.991H479.451V919.141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.65 944.003C457.65 944.189 468.84 944.334 482.657 944.334C496.475 944.334 507.665 944.189 507.665 944.003C507.665 943.816 496.475 943.672 482.657 943.672C468.84 943.651 457.65 943.816 457.65 944.003Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.451 955.11H487.911V972.961H479.451V955.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M457.65 979.973C457.65 980.159 468.84 980.304 482.657 980.304C496.474 980.304 507.664 980.159 507.664 979.973C507.664 979.787 496.474 979.642 482.657 979.642C468.84 979.642 457.65 979.787 457.65 979.973Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M479.451 991.101H487.911V1008.95H479.451V991.101Z",
    fill: "#FAFAFA"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M700.053 897.136H838.646V1079.92H700.053V897.136Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.071 897.136H765.047V1079.92H700.071V897.136Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.128 921.887H809.592V952.162H797.128V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.128 1040.37H809.592V1070.64H797.128V1040.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.048 964.043C765.048 964.379 781.531 964.663 801.856 964.663C822.181 964.663 838.664 964.379 838.664 964.043C838.664 963.707 822.181 963.423 801.856 963.423C781.513 963.423 765.048 963.689 765.048 964.043Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.128 981.569H809.592V1011.84H797.128V981.569Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M765.048 1023.72C765.048 1024.06 781.531 1024.34 801.856 1024.34C822.181 1024.34 838.664 1024.06 838.664 1023.72C838.664 1023.39 822.181 1023.1 801.856 1023.1C781.513 1023.1 765.048 1023.39 765.048 1023.72Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.773 921.887H751.237V952.162H738.773V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.738 921.887H724.202V952.162H711.738V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.773 979.321H751.237V1009.6H738.773V979.321Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.738 979.321H724.202V1009.6H711.738V979.321Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M738.773 1036.77H751.237V1067.05H738.773V1036.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M711.738 1036.77H724.202V1067.05H711.738V1036.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.642 890.762H849.073V897.348H689.642V890.762Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M699.096 897.986C699.096 898.322 730.08 898.605 768.269 898.605C806.476 898.605 837.459 898.322 837.459 897.986C837.459 897.649 806.493 897.366 768.269 897.366C730.062 897.366 699.096 897.632 699.096 897.986Z",
    fill: "#EBEBEB"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1075 762H975V1080H1075V762Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1074.78 761.671H1024.79V1080H1074.78V761.671Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.52 730.562H986.21V761.671H1021.52V730.562Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1021.52 730.562H1013.1V761.671H1021.52V730.562Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M966.457 761.671V759.851H1077.7V761.671",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.98 775.239H994.525V793.09H1002.98V775.239Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.79 800.102C1024.79 800.288 1013.6 800.433 999.779 800.433C985.962 800.433 974.771 800.288 974.771 800.102C974.771 799.916 985.962 799.771 999.779 799.771C1013.6 799.75 1024.79 799.916 1024.79 800.102Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 775.24H1044.95V793.091H1053.41V775.24Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.21 800.102C1075.21 800.288 1064.02 800.433 1050.21 800.433C1036.39 800.433 1025.2 800.288 1025.2 800.102C1025.2 799.916 1036.39 799.771 1050.21 799.771C1064.02 799.75 1075.21 799.916 1075.21 800.102Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 810.672H1044.95V828.523H1053.41V810.672Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.21 835.535C1075.21 835.721 1064.02 835.866 1050.21 835.866C1036.39 835.866 1025.2 835.721 1025.2 835.535C1025.2 835.349 1036.39 835.204 1050.21 835.204C1064.02 835.183 1075.21 835.349 1075.21 835.535Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 847.179H1044.95V865.03H1053.41V847.179Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.21 872.043C1075.21 872.229 1064.02 872.374 1050.21 872.374C1036.39 872.374 1025.2 872.229 1025.2 872.043C1025.2 871.857 1036.39 871.712 1050.21 871.712C1064.02 871.691 1075.21 871.857 1075.21 872.043Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 883.688H1044.95V901.538H1053.41V883.688Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.21 908.529C1075.21 908.716 1064.02 908.86 1050.21 908.86C1036.39 908.86 1025.2 908.716 1025.2 908.529C1025.2 908.343 1036.39 908.198 1050.21 908.198C1064.02 908.198 1075.21 908.343 1075.21 908.529Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 919.141H1044.95V936.991H1053.41V919.141Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.22 944.003C1075.22 944.189 1064.02 944.334 1050.21 944.334C1036.39 944.334 1025.2 944.189 1025.2 944.003C1025.2 943.816 1036.39 943.672 1050.21 943.672C1064.02 943.651 1075.22 943.816 1075.22 944.003Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 954.738H1044.95V972.589H1053.41V954.738Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1053.41 990.812H1044.95V1008.66H1053.41V990.812Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1075.21 979.6C1075.21 979.787 1064.02 979.931 1050.21 979.931C1036.39 979.931 1025.2 979.787 1025.2 979.6C1025.2 979.414 1036.39 979.27 1050.21 979.27C1064.02 979.27 1075.21 979.414 1075.21 979.6Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.98 811.21H994.525V829.061H1002.98V811.21Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.79 836.072C1024.79 836.258 1013.6 836.403 999.779 836.403C985.962 836.403 974.771 836.258 974.771 836.072C974.771 835.886 985.962 835.741 999.779 835.741C1013.6 835.72 1024.79 835.886 1024.79 836.072Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.98 847.201H994.525V865.051H1002.98V847.201Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.79 872.043C1024.79 872.229 1013.6 872.374 999.779 872.374C985.962 872.374 974.771 872.229 974.771 872.043C974.771 871.857 985.962 871.712 999.779 871.712C1013.6 871.712 1024.79 871.857 1024.79 872.043Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.98 883.171H994.525V901.021H1002.98V883.171Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.79 908.013C1024.79 908.199 1013.6 908.343 999.779 908.343C985.962 908.343 974.771 908.199 974.771 908.013C974.771 907.826 985.962 907.682 999.779 907.682C1013.6 907.682 1024.79 907.826 1024.79 908.013Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.98 919.141H994.525V936.991H1002.98V919.141Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.79 944.003C1024.79 944.189 1013.6 944.334 999.779 944.334C985.962 944.334 974.772 944.189 974.772 944.003C974.772 943.817 985.962 943.672 999.779 943.672C1013.6 943.651 1024.79 943.817 1024.79 944.003Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.98 955.11H994.525V972.961H1002.98V955.11Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.79 979.973C1024.79 980.159 1013.6 980.304 999.779 980.304C985.962 980.304 974.771 980.159 974.771 979.973C974.771 979.787 985.962 979.642 999.779 979.642C1013.6 979.642 1024.79 979.787 1024.79 979.973Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1002.99 991.101H994.526V1008.95H1002.99V991.101Z",
    fill: "#FAFAFA"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M258.243 897.136H396.836V1079.92H258.243V897.136Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.261 897.136H323.237V1079.92H258.261V897.136Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.317 921.887H367.781V952.162H355.317V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.317 1040.37H367.781V1070.64H355.317V1040.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.237 964.043C323.237 964.379 339.72 964.663 360.045 964.663C380.37 964.663 396.853 964.379 396.853 964.043C396.853 963.707 380.37 963.423 360.045 963.423C339.702 963.423 323.237 963.689 323.237 964.043Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.317 981.569H367.781V1011.84H355.317V981.569Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.237 1023.72C323.237 1024.06 339.72 1024.34 360.045 1024.34C380.37 1024.34 396.853 1024.06 396.853 1023.72C396.853 1023.39 380.37 1023.1 360.045 1023.1C339.702 1023.1 323.237 1023.39 323.237 1023.72Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.963 921.887H309.427V952.162H296.963V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.928 921.887H282.392V952.162H269.928V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.963 979.321H309.427V1009.6H296.963V979.321Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.928 979.321H282.392V1009.6H269.928V979.321Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.963 1036.77H309.427V1067.05H296.963V1036.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.928 1036.77H282.392V1067.05H269.928V1036.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.832 890.762H407.263V897.348H247.832V890.762Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.287 897.986C257.287 898.322 288.27 898.605 326.459 898.605C364.666 898.605 395.649 898.322 395.649 897.986C395.649 897.649 364.684 897.366 326.459 897.366C288.253 897.366 257.287 897.632 257.287 897.986Z",
    fill: "#EBEBEB"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M699.056 833.144C698.383 828.31 705.217 824.327 710.352 823.92C712.795 823.725 715.344 824.097 717.664 823.282C722.692 821.529 724.692 815.049 729.597 812.978C733.262 811.438 737.475 812.801 741.034 814.589C744.593 816.377 748.098 818.626 752.064 818.874C755.516 819.086 759.27 817.811 762.28 819.493C764.528 820.75 765.714 823.335 767.786 824.876C769.822 826.38 772.46 826.681 774.974 826.823C777.488 826.965 780.09 826.982 782.392 828.027C784.676 829.072 786.588 831.497 786.11 833.976L699.056 833.144Z",
    fill: "#F5F5F5"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1224.19 897.136H1085.6V1079.92H1224.19V897.136Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.18 897.136H1159.2V1079.92H1224.18V897.136Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.12 921.887H1114.65V952.162H1127.12V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.12 1040.37H1114.65V1070.64H1127.12V1040.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2 964.043C1159.2 964.379 1142.72 964.663 1122.39 964.663C1102.07 964.663 1085.58 964.379 1085.58 964.043C1085.58 963.707 1102.07 963.423 1122.39 963.423C1142.73 963.423 1159.2 963.689 1159.2 964.043Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1127.12 981.569H1114.65V1011.84H1127.12V981.569Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.2 1023.72C1159.2 1024.06 1142.72 1024.34 1122.39 1024.34C1102.07 1024.34 1085.58 1024.06 1085.58 1023.72C1085.58 1023.39 1102.07 1023.1 1122.39 1023.1C1142.73 1023.1 1159.2 1023.39 1159.2 1023.72Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.47 921.887H1173.01V952.162H1185.47V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.51 921.887H1200.04V952.162H1212.51V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.47 979.321H1173.01V1009.6H1185.47V979.321Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.51 979.321H1200.04V1009.6H1212.51V979.321Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.47 1036.77H1173.01V1067.05H1185.47V1036.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.51 1036.77H1200.04V1067.05H1212.51V1036.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1234.6 890.762H1075.17V897.348H1234.6V890.762Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.15 897.986C1225.15 898.322 1194.17 898.605 1155.98 898.605C1117.77 898.605 1086.79 898.322 1086.79 897.986C1086.79 897.649 1117.75 897.366 1155.98 897.366C1194.18 897.366 1225.15 897.632 1225.15 897.986Z",
    fill: "#EBEBEB"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M837.723 760.619C838.767 753.042 828.074 746.81 820.053 746.172C816.229 745.871 812.246 746.455 808.616 745.181C800.755 742.436 797.621 732.292 789.938 729.052C784.201 726.626 777.597 728.786 772.038 731.583C766.479 734.381 760.99 737.904 754.776 738.294C749.376 738.648 743.498 736.629 738.771 739.267C735.248 741.233 733.406 745.287 730.149 747.695C726.98 750.032 722.837 750.528 718.889 750.74C714.94 750.952 710.868 750.988 707.274 752.634C703.68 754.281 700.723 758.07 701.467 761.947L837.723 760.619Z",
    fill: "#EBEBEB"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.5 1080H87.5488L87 879H212.951L213.5 1080Z",
    fill: "#EBEBEB"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M656 1080H529.551L529 879H655.449L656 1080Z",
    fill: "#EBEBEB"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1268.42 1080H1394.37L1394.92 878.903H1268.97L1268.42 1080Z",
    fill: "#EBEBEB"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M655 879H592V1080H655V879Z",
    fill: "#E0E0E0"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M213.467 878.903H150.492V1080H213.467V878.903Z",
    fill: "#E0E0E0"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.176 839.722H543.702V878.903H588.176V839.722Z",
    fill: "#EBEBEB"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1268.97 878.903H1331.94V1080H1268.97V878.903Z",
    fill: "#E0E0E0"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M588.176 839.722H577.571V878.903H588.176V839.722Z",
    fill: "#E0E0E0"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.366 839.722H101.892V878.903H146.366V839.722Z",
    fill: "#EBEBEB"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M658.959 876.619H518.826V878.903H658.959V876.619Z",
    fill: "#E0E0E0"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1336.07 839.722H1380.54V878.903H1336.07V839.722Z",
    fill: "#EBEBEB"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.841 896.006H554.183V918.491H564.841V896.006Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M146.367 839.722H135.761V878.903H146.367V839.722Z",
    fill: "#E0E0E0"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.301 927.307C592.301 927.537 578.208 927.732 560.822 927.732C543.436 927.732 529.326 927.537 529.326 927.307C529.326 927.077 543.419 926.882 560.822 926.882C578.191 926.882 592.301 927.059 592.301 927.307Z",
    fill: "#E0E0E0"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1336.07 839.722H1346.67V878.903H1336.07V839.722Z",
    fill: "#E0E0E0"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.366 896.006H617.708V918.491H628.366V896.006Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.826 927.308C655.826 927.538 641.733 927.733 624.347 927.733C606.961 927.733 592.851 927.538 592.851 927.308C592.851 927.077 606.944 926.883 624.347 926.883C641.716 926.883 655.826 927.06 655.826 927.308Z",
    fill: "#EBEBEB"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.15 876.619H77.0168V878.903H217.15V876.619Z",
    fill: "#E0E0E0"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.366 940.639H617.708V963.124H628.366V940.639Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.826 971.941C655.826 972.171 641.733 972.366 624.347 972.366C606.961 972.366 592.85 972.171 592.85 971.941C592.85 971.711 606.943 971.516 624.347 971.516C641.715 971.498 655.826 971.693 655.826 971.941Z",
    fill: "#EBEBEB"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1265.29 876.619H1405.42V878.903H1265.29V876.619Z",
    fill: "#E0E0E0"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.366 986.619H617.708V1009.1H628.366V986.619Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.826 1017.92C655.826 1018.15 641.733 1018.35 624.347 1018.35C606.961 1018.35 592.85 1018.15 592.85 1017.92C592.85 1017.69 606.943 1017.5 624.347 1017.5C641.715 1017.48 655.826 1017.67 655.826 1017.92Z",
    fill: "#EBEBEB"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.032 896.006H112.374V918.491H123.032V896.006Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.4 896.006H1370.06V918.491H1359.4V896.006Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.841 941.312H554.183V963.797H564.841V941.312Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.492 927.307C150.492 927.537 136.399 927.732 119.013 927.732C101.627 927.732 87.516 927.537 87.516 927.307C87.516 927.077 101.609 926.882 119.013 926.882C136.381 926.882 150.492 927.059 150.492 927.307Z",
    fill: "#E0E0E0"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.301 972.614C592.301 972.845 578.208 973.039 560.822 973.039C543.436 973.039 529.326 972.845 529.326 972.614C529.326 972.384 543.419 972.189 560.822 972.189C578.191 972.189 592.301 972.384 592.301 972.614Z",
    fill: "#E0E0E0"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1331.94 927.307C1331.94 927.537 1346.04 927.732 1363.42 927.732C1380.81 927.732 1394.92 927.537 1394.92 927.307C1394.92 927.077 1380.83 926.882 1363.42 926.882C1346.05 926.882 1331.94 927.059 1331.94 927.307Z",
    fill: "#E0E0E0"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.841 986.618H554.183V1009.1H564.841V986.618Z",
    fill: "white"
  }))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.557 896.006H175.898V918.491H186.557V896.006Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.017 927.308C214.017 927.538 199.924 927.733 182.538 927.733C165.152 927.733 151.041 927.538 151.041 927.308C151.041 927.077 165.134 926.883 182.538 926.883C199.906 926.883 214.017 927.06 214.017 927.308Z",
    fill: "#EBEBEB"
  }))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M592.301 1017.92C592.301 1018.15 578.208 1018.34 560.822 1018.34C543.436 1018.34 529.326 1018.15 529.326 1017.92C529.326 1017.69 543.419 1017.5 560.822 1017.5C578.191 1017.5 592.301 1017.69 592.301 1017.92Z",
    fill: "#E0E0E0"
  }))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1295.88 896.006H1306.54V918.491H1295.88V896.006Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.42 927.308C1268.42 927.538 1282.51 927.733 1299.9 927.733C1317.29 927.733 1331.4 927.538 1331.4 927.308C1331.4 927.077 1317.3 926.883 1299.9 926.883C1282.53 926.883 1268.42 927.06 1268.42 927.308Z",
    fill: "#EBEBEB"
  }))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M564.841 1031.94H554.183V1054.43H564.841V1031.94Z",
    fill: "white"
  }))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.556 940.639H175.898V963.124H186.556V940.639Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.016 971.941C214.016 972.171 199.923 972.366 182.537 972.366C165.151 972.366 151.041 972.171 151.041 971.941C151.041 971.711 165.133 971.516 182.537 971.516C199.906 971.498 214.016 971.693 214.016 971.941Z",
    fill: "#EBEBEB"
  }))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1295.88 940.639H1306.54V963.124H1295.88V940.639Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.42 971.941C1268.42 972.171 1282.51 972.366 1299.9 972.366C1317.29 972.366 1331.4 972.171 1331.4 971.941C1331.4 971.711 1317.3 971.516 1299.9 971.516C1282.53 971.498 1268.42 971.693 1268.42 971.941Z",
    fill: "#EBEBEB"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.556 986.619H175.898V1009.1H186.556V986.619Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.016 1017.92C214.016 1018.15 199.923 1018.35 182.537 1018.35C165.151 1018.35 151.041 1018.15 151.041 1017.92C151.041 1017.69 165.134 1017.5 182.537 1017.5C199.906 1017.48 214.016 1017.67 214.016 1017.92Z",
    fill: "#EBEBEB"
  }))), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1295.88 986.619H1306.54V1009.1H1295.88V986.619Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1268.42 1017.92C1268.42 1018.15 1282.51 1018.35 1299.9 1018.35C1317.29 1018.35 1331.4 1018.15 1331.4 1017.92C1331.4 1017.69 1317.3 1017.5 1299.9 1017.5C1282.53 1017.48 1268.42 1017.67 1268.42 1017.92Z",
    fill: "#EBEBEB"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.556 1032.58H175.898V1055.07H186.556V1032.58Z",
    fill: "#F5F5F5"
  }))), _g48 || (_g48 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M628.366 1032.58H617.708V1055.07H628.366V1032.58Z",
    fill: "#F5F5F5"
  }))), _g49 || (_g49 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1295.88 1032.58H1306.54V1055.07H1295.88V1032.58Z",
    fill: "#F5F5F5"
  }))), _g50 || (_g50 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.031 941.312H112.373V963.797H123.031V941.312Z",
    fill: "white"
  }))), _g51 || (_g51 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.4 941.312H1370.06V963.797H1359.4V941.312Z",
    fill: "white"
  }))), _g52 || (_g52 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.492 972.614C150.492 972.845 136.399 973.039 119.013 973.039C101.627 973.039 87.516 972.845 87.516 972.614C87.516 972.384 101.609 972.189 119.013 972.189C136.381 972.189 150.492 972.384 150.492 972.614Z",
    fill: "#E0E0E0"
  }))), _g53 || (_g53 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1331.94 972.614C1331.94 972.845 1346.04 973.039 1363.42 973.039C1380.81 973.039 1394.92 972.845 1394.92 972.614C1394.92 972.384 1380.83 972.189 1363.42 972.189C1346.05 972.189 1331.94 972.384 1331.94 972.614Z",
    fill: "#E0E0E0"
  }))), _g54 || (_g54 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.032 986.618H112.373V1009.1H123.032V986.618Z",
    fill: "white"
  }))), _g55 || (_g55 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.4 986.618H1370.06V1009.1H1359.4V986.618Z",
    fill: "white"
  }))), _g56 || (_g56 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M150.492 1017.92C150.492 1018.15 136.399 1018.34 119.013 1018.34C101.627 1018.34 87.516 1018.15 87.516 1017.92C87.516 1017.69 101.609 1017.5 119.013 1017.5C136.381 1017.5 150.492 1017.69 150.492 1017.92Z",
    fill: "#E0E0E0"
  }))), _g57 || (_g57 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1331.94 1017.92C1331.94 1018.15 1346.04 1018.34 1363.42 1018.34C1380.81 1018.34 1394.92 1018.15 1394.92 1017.92C1394.92 1017.69 1380.83 1017.5 1363.42 1017.5C1346.05 1017.5 1331.94 1017.69 1331.94 1017.92Z",
    fill: "#E0E0E0"
  }))), _g58 || (_g58 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.032 1031.94H112.374V1054.43H123.032V1031.94Z",
    fill: "white"
  }))), _g59 || (_g59 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1359.4 1031.94H1370.06V1054.43H1359.4V1031.94Z",
    fill: "white"
  }))), _g60 || (_g60 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257.246 833.144C256.574 828.31 263.408 824.327 268.542 823.92C270.985 823.725 273.535 824.097 275.854 823.282C280.882 821.529 282.883 815.049 287.787 812.978C291.452 811.438 295.666 812.801 299.224 814.589C302.783 816.377 306.288 818.626 310.254 818.874C313.707 819.086 317.46 817.811 320.47 819.493C322.718 820.75 323.905 823.335 325.976 824.876C328.012 826.38 330.65 826.681 333.164 826.823C335.678 826.965 338.281 826.982 340.583 828.027C342.866 829.072 344.779 831.497 344.301 833.976L257.246 833.144Z",
    fill: "#F5F5F5"
  }))), _g61 || (_g61 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1225.19 833.144C1225.86 828.31 1219.03 824.327 1213.89 823.92C1211.45 823.725 1208.9 824.097 1206.58 823.282C1201.55 821.529 1199.55 815.049 1194.65 812.978C1190.98 811.438 1186.77 812.801 1183.21 814.589C1179.65 816.377 1176.15 818.626 1172.18 818.874C1168.73 819.086 1164.98 817.811 1161.97 819.493C1159.72 820.75 1158.53 823.335 1156.46 824.876C1154.42 826.38 1151.79 826.681 1149.27 826.823C1146.76 826.965 1144.16 826.982 1141.85 828.027C1139.57 829.072 1137.66 831.497 1138.14 833.976L1225.19 833.144Z",
    fill: "#F5F5F5"
  }))), _g62 || (_g62 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M395.913 760.619C396.958 753.042 386.264 746.81 378.244 746.172C374.42 745.871 370.436 746.455 366.807 745.181C358.946 742.436 355.812 732.292 348.128 729.052C342.392 726.626 335.788 728.786 330.229 731.583C324.669 734.381 319.181 737.904 312.966 738.294C307.566 738.648 301.689 736.629 296.961 739.267C293.438 741.233 291.597 745.287 288.339 747.695C285.17 750.032 281.027 750.528 277.079 750.74C273.131 750.952 269.059 750.988 265.465 752.634C261.871 754.281 258.914 758.07 259.658 761.947L395.913 760.619Z",
    fill: "#EBEBEB"
  }))), _g63 || (_g63 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1086.52 760.619C1085.48 753.042 1096.17 746.81 1104.19 746.172C1108.02 745.871 1112 746.455 1115.63 745.181C1123.49 742.436 1126.62 732.292 1134.31 729.052C1140.04 726.626 1146.65 728.786 1152.21 731.583C1157.77 734.381 1163.26 737.904 1169.47 738.294C1174.87 738.648 1180.75 736.629 1185.48 739.267C1189 741.233 1190.84 745.287 1194.1 747.695C1197.27 750.032 1201.41 750.528 1205.36 750.74C1209.31 750.952 1213.38 750.988 1216.97 752.634C1220.57 754.281 1223.52 758.07 1222.78 761.947L1086.52 760.619Z",
    fill: "#EBEBEB"
  }))), _g64 || (_g64 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M135.708 805.518C136.54 799.48 128.024 794.505 121.615 793.992C118.57 793.744 115.383 794.204 112.497 793.213C106.23 791.035 103.733 782.927 97.6076 780.359C93.0398 778.43 87.7638 780.147 83.3376 782.378C78.9114 784.608 74.5206 787.424 69.581 787.724C65.2787 788.008 60.6047 786.397 56.8336 788.503C54.0185 790.079 52.549 793.301 49.9642 795.214C47.4324 797.073 44.1216 797.48 40.9879 797.639C37.8541 797.816 34.5965 797.834 31.7283 799.144C28.8601 800.454 26.5054 803.482 27.0897 806.562L135.708 805.518Z",
    fill: "#F5F5F5"
  }))), _g65 || (_g65 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1675.24 807.939H1760.82V1079.19H1675.24V807.939Z",
    fill: "#F5F5F5"
  }))), _g66 || (_g66 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1675 808H1718V1080H1675V808Z",
    fill: "#EBEBEB"
  }))), _g67 || (_g67 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1720.83 781.294H1751.05V807.922H1720.83V781.294Z",
    fill: "#F5F5F5"
  }))), _g68 || (_g68 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1720.83 781.294H1728.03V807.922H1720.83V781.294Z",
    fill: "#EBEBEB"
  }))), _g69 || (_g69 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1767.96 807.94V806.382H1672.73V807.94",
    fill: "#E0E0E0"
  }))), _g70 || (_g70 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1736.69 819.554H1743.93V834.833H1736.69V819.554Z",
    fill: "#FAFAFA"
  }))), _g71 || (_g71 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1718.03 840.816C1718.03 840.976 1727.61 841.1 1739.44 841.1C1751.26 841.1 1760.84 840.976 1760.84 840.816C1760.84 840.657 1751.26 840.533 1739.44 840.533C1727.61 840.533 1718.03 840.657 1718.03 840.816Z",
    fill: "#E0E0E0"
  }))), _g72 || (_g72 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1693.53 819.554H1700.77V834.833H1693.53V819.554Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.87 840.817C1674.87 840.976 1684.45 841.1 1696.27 841.1C1708.1 841.1 1717.68 840.976 1717.68 840.817C1717.68 840.657 1708.1 840.533 1696.27 840.533C1684.45 840.533 1674.87 840.657 1674.87 840.817Z",
    fill: "#E0E0E0"
  }))), _g73 || (_g73 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1693.53 849.883H1700.77V865.162H1693.53V849.883Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.87 871.146C1674.87 871.305 1684.45 871.429 1696.27 871.429C1708.1 871.429 1717.68 871.305 1717.68 871.146C1717.68 870.987 1708.1 870.863 1696.27 870.863C1684.45 870.863 1674.87 870.987 1674.87 871.146Z",
    fill: "#E0E0E0"
  }))), _g74 || (_g74 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1693.53 881.113H1700.77V896.392H1693.53V881.113Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.87 902.394C1674.87 902.554 1684.45 902.678 1696.27 902.678C1708.1 902.678 1717.68 902.554 1717.68 902.394C1717.68 902.235 1708.1 902.111 1696.27 902.111C1684.45 902.111 1674.87 902.235 1674.87 902.394Z",
    fill: "#E0E0E0"
  }))), _g75 || (_g75 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1693.53 912.363H1700.77V927.642H1693.53V912.363Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.87 933.644C1674.87 933.803 1684.45 933.927 1696.27 933.927C1708.1 933.927 1717.68 933.803 1717.68 933.644C1717.68 933.485 1708.1 933.361 1696.27 933.361C1684.45 933.343 1674.87 933.485 1674.87 933.644Z",
    fill: "#E0E0E0"
  }))), _g76 || (_g76 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1693.53 942.726H1700.77V958.005H1693.53V942.726Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.87 963.988C1674.87 964.148 1684.45 964.272 1696.27 964.272C1708.1 964.272 1717.68 964.148 1717.68 963.988C1717.68 963.829 1708.1 963.705 1696.27 963.705C1684.45 963.705 1674.87 963.829 1674.87 963.988Z",
    fill: "#E0E0E0"
  }))), _g77 || (_g77 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1693.53 973.196H1700.77V988.475H1693.53V973.196Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1693.53 1004.07H1700.77V1019.35H1693.53V1004.07Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1674.87 994.459C1674.87 994.618 1684.45 994.742 1696.27 994.742C1708.1 994.742 1717.68 994.618 1717.68 994.459C1717.68 994.299 1708.1 994.175 1696.27 994.175C1684.45 994.175 1674.87 994.299 1674.87 994.459Z",
    fill: "#E0E0E0"
  }))), _g78 || (_g78 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1736.69 850.343H1743.93V865.622H1736.69V850.343Z",
    fill: "#FAFAFA"
  }))), _g79 || (_g79 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1718.03 871.606C1718.03 871.765 1727.61 871.889 1739.44 871.889C1751.26 871.889 1760.84 871.765 1760.84 871.606C1760.84 871.446 1751.26 871.322 1739.44 871.322C1727.61 871.322 1718.03 871.446 1718.03 871.606Z",
    fill: "#E0E0E0"
  }))), _g80 || (_g80 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1736.69 881.131H1743.93V896.41H1736.69V881.131Z",
    fill: "#FAFAFA"
  }))), _g81 || (_g81 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1718.03 902.413C1718.03 902.572 1727.61 902.696 1739.44 902.696C1751.26 902.696 1760.84 902.572 1760.84 902.413C1760.84 902.253 1751.26 902.129 1739.44 902.129C1727.61 902.112 1718.03 902.253 1718.03 902.413Z",
    fill: "#E0E0E0"
  }))), _g82 || (_g82 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1736.69 911.92H1743.93V927.199H1736.69V911.92Z",
    fill: "#FAFAFA"
  }))), _g83 || (_g83 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1718.03 933.201C1718.03 933.36 1727.61 933.484 1739.44 933.484C1751.26 933.484 1760.84 933.36 1760.84 933.201C1760.84 933.041 1751.26 932.918 1739.44 932.918C1727.61 932.9 1718.03 933.041 1718.03 933.201Z",
    fill: "#E0E0E0"
  }))), _g84 || (_g84 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1736.69 942.726H1743.93V958.005H1736.69V942.726Z",
    fill: "#FAFAFA"
  }))), _g85 || (_g85 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1718.03 963.988C1718.03 964.148 1727.61 964.272 1739.44 964.272C1751.26 964.272 1760.84 964.148 1760.84 963.988C1760.84 963.829 1751.26 963.705 1739.44 963.705C1727.61 963.705 1718.03 963.829 1718.03 963.988Z",
    fill: "#E0E0E0"
  }))), _g86 || (_g86 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1736.69 973.515H1743.93V988.794H1736.69V973.515Z",
    fill: "#FAFAFA"
  }))), _g87 || (_g87 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1718.03 994.777C1718.03 994.937 1727.61 995.061 1739.44 995.061C1751.26 995.061 1760.84 994.937 1760.84 994.777C1760.84 994.618 1751.26 994.494 1739.44 994.494C1727.61 994.494 1718.03 994.618 1718.03 994.777Z",
    fill: "#E0E0E0"
  }))), _g88 || (_g88 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1736.69 1004.3H1743.93V1019.58H1736.69V1004.3Z",
    fill: "#FAFAFA"
  }))), _g89 || (_g89 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1513.32 761.798H1413.34V1080H1513.32V761.798Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.34 761.798H1463.35V1080H1513.34V761.798Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.08 730.562H1424.77V761.798H1460.08V730.562Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1460.08 730.562H1451.66V761.798H1460.08V730.562Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.02 761.798V759.971H1516.26V761.798",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.55 775.422H1433.09V793.346H1441.55V775.422Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.35 800.387C1463.35 800.574 1452.16 800.719 1438.34 800.719C1424.53 800.719 1413.34 800.574 1413.34 800.387C1413.34 800.2 1424.53 800.054 1438.34 800.054C1452.16 800.034 1463.35 800.2 1463.35 800.387Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 775.423H1483.52V793.347H1491.98V775.423Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.78 800.387C1513.78 800.574 1502.59 800.719 1488.77 800.719C1474.95 800.719 1463.76 800.574 1463.76 800.387C1463.76 800.2 1474.95 800.055 1488.77 800.055C1502.59 800.034 1513.78 800.2 1513.78 800.387Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 811H1483.52V828.924H1491.98V811Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.78 835.964C1513.78 836.151 1502.59 836.297 1488.77 836.297C1474.95 836.297 1463.76 836.151 1463.76 835.964C1463.76 835.777 1474.95 835.632 1488.77 835.632C1502.59 835.611 1513.78 835.777 1513.78 835.964Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 847.657H1483.52V865.581H1491.98V847.657Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.78 872.622C1513.78 872.809 1502.59 872.954 1488.77 872.954C1474.95 872.954 1463.76 872.809 1463.76 872.622C1463.76 872.435 1474.95 872.29 1488.77 872.29C1502.59 872.269 1513.78 872.435 1513.78 872.622Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 884.315H1483.52V902.239H1491.98V884.315Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.78 909.258C1513.78 909.445 1502.59 909.59 1488.77 909.59C1474.95 909.59 1463.76 909.445 1463.76 909.258C1463.76 909.071 1474.95 908.926 1488.77 908.926C1502.59 908.926 1513.78 909.071 1513.78 909.258Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 919.913H1483.52V937.837H1491.98V919.913Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.78 944.876C1513.78 945.063 1502.59 945.209 1488.77 945.209C1474.95 945.209 1463.76 945.063 1463.76 944.876C1463.76 944.69 1474.95 944.544 1488.77 944.544C1502.59 944.523 1513.78 944.69 1513.78 944.876Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 955.656H1483.52V973.58H1491.98V955.656Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1491.98 991.878H1483.52V1009.8H1491.98V991.878Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1513.78 980.62C1513.78 980.807 1502.59 980.952 1488.77 980.952C1474.95 980.952 1463.76 980.807 1463.76 980.62C1463.76 980.433 1474.95 980.288 1488.77 980.288C1502.59 980.288 1513.78 980.433 1513.78 980.62Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.55 811.54H1433.09V829.464H1441.55V811.54Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.35 836.504C1463.35 836.691 1452.16 836.837 1438.34 836.837C1424.53 836.837 1413.34 836.691 1413.34 836.504C1413.34 836.317 1424.53 836.172 1438.34 836.172C1452.16 836.151 1463.35 836.317 1463.35 836.504Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.55 847.678H1433.09V865.602H1441.55V847.678Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.35 872.622C1463.35 872.809 1452.16 872.955 1438.34 872.955C1424.53 872.955 1413.34 872.809 1413.34 872.622C1413.34 872.435 1424.53 872.29 1438.34 872.29C1452.16 872.29 1463.35 872.435 1463.35 872.622Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.55 883.796H1433.09V901.719H1441.55V883.796Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.35 908.739C1463.35 908.926 1452.16 909.071 1438.34 909.071C1424.53 909.071 1413.34 908.926 1413.34 908.739C1413.34 908.552 1424.53 908.407 1438.34 908.407C1452.16 908.407 1463.35 908.552 1463.35 908.739Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.55 919.913H1433.09V937.837H1441.55V919.913Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.35 944.877C1463.35 945.064 1452.16 945.209 1438.34 945.209C1424.53 945.209 1413.34 945.064 1413.34 944.877C1413.34 944.69 1424.53 944.544 1438.34 944.544C1452.16 944.524 1463.35 944.69 1463.35 944.877Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.55 956.03H1433.09V973.954H1441.55V956.03Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1463.35 980.995C1463.35 981.182 1452.16 981.327 1438.34 981.327C1424.53 981.327 1413.34 981.182 1413.34 980.995C1413.34 980.808 1424.53 980.662 1438.34 980.662C1452.16 980.662 1463.35 980.808 1463.35 980.995Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1441.55 992.168H1433.09V1010.09H1441.55V992.168Z",
    fill: "#FAFAFA"
  }))), _g90 || (_g90 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1662.76 897.136H1524.16V1079.92H1662.76V897.136Z",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1662.74 897.136H1597.76V1079.92H1662.74V897.136Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.68 921.887H1553.22V952.162H1565.68V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.68 1040.37H1553.22V1070.64H1565.68V1040.37Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1597.76 964.043C1597.76 964.379 1581.28 964.663 1560.95 964.663C1540.63 964.663 1524.15 964.379 1524.15 964.043C1524.15 963.707 1540.63 963.423 1560.95 963.423C1581.3 963.423 1597.76 963.689 1597.76 964.043Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1565.68 981.569H1553.22V1011.84H1565.68V981.569Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1597.76 1023.72C1597.76 1024.06 1581.28 1024.34 1560.95 1024.34C1540.63 1024.34 1524.15 1024.06 1524.15 1023.72C1524.15 1023.39 1540.63 1023.1 1560.95 1023.1C1581.3 1023.1 1597.76 1023.39 1597.76 1023.72Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.04 921.887H1611.57V952.162H1624.04V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.07 921.887H1638.61V952.162H1651.07V921.887Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.04 979.321H1611.57V1009.6H1624.04V979.321Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.07 979.321H1638.61V1009.6H1651.07V979.321Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.04 1036.77H1611.57V1067.05H1624.04V1036.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1651.07 1036.77H1638.61V1067.05H1651.07V1036.77Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1673.17 890.762H1513.74V897.348H1673.17V890.762Z",
    fill: "#E0E0E0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1663.71 897.986C1663.71 898.322 1632.73 898.605 1594.54 898.605C1556.33 898.605 1525.35 898.322 1525.35 897.986C1525.35 897.649 1556.32 897.366 1594.54 897.366C1632.75 897.366 1663.71 897.632 1663.71 897.986Z",
    fill: "#EBEBEB"
  }))), _g91 || (_g91 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1706.98 1080H1832.94L1833.48 878.903H1707.53L1706.98 1080Z",
    fill: "#EBEBEB"
  }))), _g92 || (_g92 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1708 879H1771V1080H1708V879Z",
    fill: "#E0E0E0"
  }))), _g93 || (_g93 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1774.63 839.722H1819.11V878.903H1774.63V839.722Z",
    fill: "#EBEBEB"
  }))), _g94 || (_g94 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1774.63 839.722H1785.24V878.903H1774.63V839.722Z",
    fill: "#E0E0E0"
  }))), _g95 || (_g95 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1703.85 876.619H1843.98V878.903H1703.85V876.619Z",
    fill: "#E0E0E0"
  }))), _g96 || (_g96 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1797.97 896.006H1808.63V918.491H1797.97V896.006Z",
    fill: "white"
  }))), _g97 || (_g97 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1770.51 927.307C1770.51 927.537 1784.6 927.732 1801.99 927.732C1819.37 927.732 1833.48 927.537 1833.48 927.307C1833.48 927.077 1819.39 926.882 1801.99 926.882C1784.62 926.882 1770.51 927.059 1770.51 927.307Z",
    fill: "#E0E0E0"
  }))), _g98 || (_g98 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1734.44 896.006H1745.1V918.491H1734.44V896.006Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.98 927.308C1706.98 927.538 1721.08 927.733 1738.46 927.733C1755.85 927.733 1769.96 927.538 1769.96 927.308C1769.96 927.077 1755.87 926.883 1738.46 926.883C1721.09 926.883 1706.98 927.06 1706.98 927.308Z",
    fill: "#EBEBEB"
  }))), _g99 || (_g99 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1734.44 940.639H1745.1V963.124H1734.44V940.639Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.98 971.941C1706.98 972.171 1721.08 972.366 1738.46 972.366C1755.85 972.366 1769.96 972.171 1769.96 971.941C1769.96 971.711 1755.87 971.516 1738.46 971.516C1721.09 971.498 1706.98 971.693 1706.98 971.941Z",
    fill: "#EBEBEB"
  }))), _g100 || (_g100 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1734.44 986.619H1745.1V1009.1H1734.44V986.619Z",
    fill: "#F5F5F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1706.98 1017.92C1706.98 1018.15 1721.08 1018.35 1738.46 1018.35C1755.85 1018.35 1769.96 1018.15 1769.96 1017.92C1769.96 1017.69 1755.87 1017.5 1738.46 1017.5C1721.09 1017.48 1706.98 1017.67 1706.98 1017.92Z",
    fill: "#EBEBEB"
  }))), _g101 || (_g101 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1734.44 1032.58H1745.1V1055.07H1734.44V1032.58Z",
    fill: "#F5F5F5"
  }))), _g102 || (_g102 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1797.97 941.312H1808.63V963.797H1797.97V941.312Z",
    fill: "white"
  }))), _g103 || (_g103 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1770.51 972.614C1770.51 972.845 1784.6 973.039 1801.99 973.039C1819.37 973.039 1833.48 972.845 1833.48 972.614C1833.48 972.384 1819.39 972.189 1801.99 972.189C1784.62 972.189 1770.51 972.384 1770.51 972.614Z",
    fill: "#E0E0E0"
  }))), _g104 || (_g104 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1797.97 986.618H1808.63V1009.1H1797.97V986.618Z",
    fill: "white"
  }))), _g105 || (_g105 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1770.51 1017.92C1770.51 1018.15 1784.6 1018.34 1801.99 1018.34C1819.37 1018.34 1833.48 1018.15 1833.48 1017.92C1833.48 1017.69 1819.39 1017.5 1801.99 1017.5C1784.62 1017.5 1770.51 1017.69 1770.51 1017.92Z",
    fill: "#E0E0E0"
  }))), _g106 || (_g106 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1797.97 1031.94H1808.63V1054.43H1797.97V1031.94Z",
    fill: "white"
  }))), _g107 || (_g107 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1663.75 833.144C1664.43 828.31 1657.59 824.327 1652.46 823.92C1650.02 823.725 1647.47 824.097 1645.15 823.282C1640.12 821.529 1638.12 815.049 1633.21 812.978C1629.55 811.438 1625.33 812.801 1621.78 814.589C1618.22 816.377 1614.71 818.626 1610.75 818.874C1607.29 819.086 1603.54 817.811 1600.53 819.493C1598.28 820.75 1597.1 823.335 1595.02 824.876C1592.99 826.38 1590.35 826.681 1587.84 826.823C1585.32 826.965 1582.72 826.982 1580.42 828.027C1578.13 829.072 1576.22 831.497 1576.7 833.976L1663.75 833.144Z",
    fill: "#F5F5F5"
  }))), _g108 || (_g108 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1525.09 760.619C1524.04 753.042 1534.74 746.81 1542.76 746.172C1546.58 745.871 1550.56 746.455 1554.19 745.181C1562.05 742.436 1565.19 732.292 1572.87 729.052C1578.61 726.626 1585.21 728.786 1590.77 731.583C1596.33 734.381 1601.82 737.904 1608.03 738.294C1613.43 738.648 1619.31 736.629 1624.04 739.267C1627.56 741.233 1629.4 745.287 1632.66 747.695C1635.83 750.032 1639.97 750.528 1643.92 750.74C1647.87 750.952 1651.94 750.988 1655.54 752.634C1659.13 754.281 1662.09 758.07 1661.34 761.947L1525.09 760.619Z",
    fill: "#EBEBEB"
  }))), _g109 || (_g109 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1785.29 805.518C1784.46 799.48 1792.98 794.505 1799.38 793.992C1802.43 793.744 1805.62 794.204 1808.5 793.213C1814.77 791.035 1817.27 782.927 1823.39 780.359C1827.96 778.43 1833.24 780.147 1837.66 782.378C1842.09 784.608 1846.48 787.424 1851.42 787.724C1855.72 788.008 1860.4 786.397 1864.17 788.503C1866.98 790.079 1868.45 793.301 1871.04 795.214C1873.57 797.073 1876.88 797.48 1880.01 797.639C1883.15 797.816 1886.4 797.834 1889.27 799.144C1892.14 800.454 1894.49 803.482 1893.91 806.562L1785.29 805.518Z",
    fill: "#F5F5F5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginWallpaper);
export default __webpack_public_path__ + "static/media/login-wallpaper.57c6af89546937ea4a4be0ebf3fd37de.svg";
export { ForwardRef as ReactComponent };